import { useMemo } from 'react';
import { useStore } from '../state/store';
import { formatDate } from '@shared/dates.js';

export function LastRowPanel() {
  const { rows, settings } = useStore((s) => ({ rows: s.rows, settings: s.settings }));
  const last = useMemo(() => {
    for (let i = rows.length - 1; i >= 0; i--) {
      if (rows[i]!.status !== 'void') return rows[i]!;
    }
    return null;
  }, [rows]);

  if (!last) {
    return (
      <div className="last-row last-row--empty">
        <div className="last-row-empty-text">Last row will appear here.</div>
      </div>
    );
  }

  const fmt = settings?.exportDateFormat ?? 'DD/MM/YYYY';
  return (
    <div className={`last-row last-row--${last.status}`}>
      <div className="last-row-cell"><span className="cell-label">Date</span>{formatDate(last.date, fmt) || '—'}</div>
      <div className="last-row-cell"><span className="cell-label">Fee earner</span>{last.feeEarner ?? '—'}</div>
      <div className="last-row-cell last-row-desc"><span className="cell-label">Description</span>{last.description}</div>
      <div className="last-row-cell"><span className="cell-label">Units</span>{last.units}</div>
      <div className="last-row-cell"><span className="cell-label">Time</span>{last.decimalTime}</div>
      <div className="last-row-cell"><span className="cell-label">Status</span>{last.status}</div>
    </div>
  );
}
